import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './AddToWishListModal.css';

const API = `${process.env.REACT_APP_API_URL || 'https://api.guardianbazaar.com'}/api`;

interface Props {
  cardId:    string;
  cardName:  string;
  imageUrl?: string | null;
  onDone:    () => void;
  onCancel:  () => void;
}

export default function AddToWishListModal({ cardId, cardName, imageUrl, onDone, onCancel }: Props) {
  const [notes,   setNotes]   = useState('');
  const [saving,  setSaving]  = useState(false);
  const textRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textRef.current?.focus();
  }, []);

  // Close on Escape
  useEffect(() => {
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onCancel]);

  const handleAdd = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/wishlist`, {
        cardId,
        notes: notes.trim() || null,
      });
      onDone();
    } catch (e) {
      console.error('Failed to add to wish list:', e);
      setSaving(false);
    }
  };

  return (
    <div className="wl-modal-overlay" onClick={onCancel}>
      <div className="wl-modal" onClick={e => e.stopPropagation()}>
        <div className="wl-modal-header">
          {imageUrl && (
            <img src={imageUrl} alt={cardName} className="wl-modal-thumb" />
          )}
          <div className="wl-modal-title-wrap">
            <div className="wl-modal-label">Add to Wish List</div>
            <div className="wl-modal-card-name">{cardName}</div>
          </div>
          <button className="wl-modal-close" onClick={onCancel}>✕</button>
        </div>
        <div className="wl-modal-body">
          <label className="wl-modal-notes-label">
            Notes <span className="wl-modal-optional">(optional)</span>
          </label>
          <textarea
            ref={textRef}
            className="wl-modal-notes"
            placeholder="e.g. combo with Blightsteel, for my Commander deck…"
            value={notes}
            onChange={e => setNotes(e.target.value)}
            rows={3}
            maxLength={500}
          />
        </div>
        <div className="wl-modal-footer">
          <button className="wl-modal-cancel" onClick={onCancel}>Cancel</button>
          <button className="wl-modal-add" onClick={handleAdd} disabled={saving}>
            {saving ? 'Adding…' : '♡ Add to Wish List'}
          </button>
        </div>
      </div>
    </div>
  );
}
